import videoPreview from './src/main'

videoPreview.install = function (Vue) {
  Vue.component(videoPreview.name, videoPreview)
}

export default videoPreview
